import { useTimeZone } from '../../../../../hooks'
import { downloadMockViewingIcs } from '../../../../RentalPortalViewing'
import { useViewingProfileContext } from '../useViewingProfileContext'

export function useViewingIcsDownload() {
  const timezone = useTimeZone()

  const { viewingData } = useViewingProfileContext()

  function handleDownloadIcs() {
    downloadMockViewingIcs({ timezone, viewing: viewingData })
  }

  return { handleDownloadIcs }
}
